export default "__VITE_ASSET__Z3JwTBNX__"